import React from 'react';
interface CTAButtonProps {
  text: string;
  href: string;
  variant?: 'primary' | 'secondary';
  className?: string;
}
export function CTAButton({
  text,
  href,
  variant = 'primary',
  className = ''
}: CTAButtonProps) {
  const baseClasses = 'font-medium px-6 py-3 rounded-md transition-colors inline-block text-center';
  const variantClasses = {
    primary: 'bg-emerald-600 hover:bg-emerald-700 text-white',
    secondary: 'bg-white hover:bg-gray-100 text-emerald-600 border border-emerald-600'
  };
  return <a href={href} className={`${baseClasses} ${variantClasses[variant]} ${className}`} data-id="element-9">
      {text}
    </a>;
}